export class MainNav {

    constructor() {
        const el = document.querySelector('#nav-trigger');
        this.showClassName = 'show-main-nav';
        this.navOpen = false;
        this.inTransition = false;

        if (!el) {
            return;
        }

        el.addEventListener('click', this.toggleNav.bind(this));

        const backToTop = document.querySelector('.back-to-top');
        backToTop.addEventListener('click', event => {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // On mobile - toggle the dropdown class
        const isTouchDevice = 'ontouchstart' in document.documentElement;
        console.log("isTouchDevice", isTouchDevice);

        if (isTouchDevice) {
            const dropdowns = document.querySelectorAll('.menu-item-has-children');
            [...dropdowns].forEach(dropdown => {
                dropdown.addEventListener('click', () => dropdown.classList.toggle('hover'));
            });
        }
    }

    toggleNav() {
        const func = this.navOpen ? 'remove' : 'add';
        document.body.classList[func](this.showClassName);
        this.navOpen = !this.navOpen;
    }

    modifyBodyClass(funcKey, className) {
        document.body.classList[funcKey](className);
    }
}